import { Country, CountryEnum } from 'types/enums';

const cleanPostalCode = (code: string | null | undefined): string | undefined => code?.replace(/[_\s]/g, '');

export const postalCodeValidator = (code: string | null | undefined, country: Country): string | null => {
  const cleanedCode = cleanPostalCode(code);

  if (!cleanedCode) {
    let zipLocalStr = 'ZIP code';
    if (country === CountryEnum.CANADA) {
      zipLocalStr = 'Postal';
    }
    if (country === CountryEnum.UK) {
      zipLocalStr = 'Postcode';
    }

    return `${zipLocalStr} is required`;
  }

  // Country-specific validation patterns
  const validationPatterns = {
    US: {
      regex: /^\d{5}$/,
      message: 'Please enter a valid US zip code (e.g., 12345)',
    },

    CA: {
      regex: /^[A-Z]\d[A-Z]\d[A-Z]\d$/i,
      message: 'Please enter a valid Canadian postal code (e.g., K1A0A6)',
    },

    GB: {
      regex: /^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/i,
      message: 'Please enter a valid UK postcode (e.g., SW1A1AA)',
    },
  };

  const pattern = validationPatterns[country];

  if (!pattern) {
    return `Validation not supported for country: ${country}`;
  }

  // Special cases for UK
  if (['GB'].includes(country)) {
    const specialCases = /^(GIR0AA|BFPO\d{1,4})$/i;
    if (specialCases.test(cleanedCode)) {
      return null; // Valid special UK postcode
    }
  }

  if (!pattern.regex.test(cleanedCode)) {
    return pattern.message;
  }

  return null;
};
